import { createTheme } from '@mui/material/styles';
const theme = createTheme({
  palette: {
    primary: {
      main: '#5EC4AC',
      background: 'rgba(94, 196, 172, 0.5)',
      300: 'rgba(94, 196, 172, 0.15)',
      loan: '#00803A',
    },
    third: {
      main: '#ffffff',
      contrastText: 'black',
    },
    revoke: {
      main: '#FF675D',
      light: '#FF675E1A',
    },
    error: {
      main: '#F98676',
      contrastText: 'white',
    },
    gradient: {
      main: 'var(--gradient-2, linear-gradient(119deg, #5FC4AC 0%, #3477BD 100%))',
      hover:
        'var(--gradient-2, linear-gradient(119deg, #5FC4AC 0%, #3477BD 80%))',
      textContract: 'white',
    },
    danger: {
      main: '#F98676',
      dark: '#ba000d',
      100: 'rgba(255, 103, 94, 1)',
      110: 'rgba(255, 103, 94, 0.1)',
    },
    text: {
      primary: 'rgba(20, 20, 43, 1)',
      secondary: 'rgba(0, 0, 0, 0.65)',
    },
    gray: {
      icon: '#F9F9F9',
    },
    divider: 'rgba(0, 0, 0, 0.10)',
    contract: {
      locked: 'rgba(97, 199, 223, 1)',
      lockedBg: 'rgba(97, 199, 223, 0.2)',
      default: 'rgba(173, 20, 87, 1)',
      defaultBg: 'rgba(173, 20, 87, 0.2)',
      released: 'rgba(0, 128, 58, 1)',
      releasedBg: 'rgba(0, 128, 58, 0.2)',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          fontWeight: '600',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          // height: '53px',
          fontSize: '14px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: '14px',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        filledError: {
          color: 'white',
        },
      },
    },
  },
  typography: {
    '14-500': {
      fontSize: '14px !important',
      fontWeight: '500',
    },
    '14-600': {
      fontSize: '14px !important',
      fontWeight: '600',
    },
    '16-600': {
      fontSize: '16px !important',
      fontWeight: '600',
    },
    '18-700': {
      fontSize: '18px !important',
      fontWeight: '700',
    },
    '20-600': {
      fontSize: '20px !important',
      fontWeight: '600',
    },
    '21-700': {
      fontSize: '21px !important',
      fontWeight: '700',
    },
    '22-600': {
      fontSize: '22px !important',
      fontWeight: '600',
    },
    '24-600': {
      fontSize: '24px !important',
      fontWeight: '600',
    },
    '24-700': {
      fontSize: '24px !important',
      fontWeight: '700',
    },
    '32-600': {
      fontSize: '32px !important',
      fontWeight: '600',
    },
  },
});
export default theme;
